import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { PseudoStates } from '@cordata/buffet';
import { CardColumns, Nav, NavLink, NavItem, TabContent, TabPane } from 'reactstrap';
import { orderBy } from 'lodash';
import classnames from 'classnames';

import { deburrObject } from '~/utils/api/normalizers';

import { Card } from '~/components/CareTeam';
import { store } from '~/utils/care-team';

const CareTeamCardColumns = ({ params, onClick }) => {
  const [status, data] = store.fetchAll({ patient: params.patient_uid });
  const [activeTab, setActiveTab] = useState('1');

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  if (status !== 'success') {
    return <PseudoStates status={status} />;
  }

  return (
    <>
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '1' })}
            onClick={() => { toggle('1'); }}
          >
            Active
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '2' })}
            onClick={() => { toggle('2'); }}
          >
            Inactive
          </NavLink>
        </NavItem>
      </Nav>

      <TabContent activeTab={activeTab} className="pt-3">
        <TabPane tabId="1">
          <CardColumns>
            {orderBy(data.map(deburrObject).filter(d => d.careTeam), ['isPrimary']).map(d => <Card key={d.id} data={d} onClick={onClick} />) }
          </CardColumns>
        </TabPane>

        <TabPane tabId="2">
          <CardColumns>
            {orderBy(data.map(deburrObject).filter(d => !d.careTeam), ['isPrimary']).map(d => <Card key={d.id} data={d} onClick={onClick} />) }
          </CardColumns>
        </TabPane>
      </TabContent>
    </>
  );
};

CareTeamCardColumns.propTypes = {
  params: PropTypes.shape().isRequired,
  onClick: PropTypes.func.isRequired,
};

export default CareTeamCardColumns;
